import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: "[radrQueryHeader]" })
export class QueryHeaderDirective {
  constructor(public template: TemplateRef<any>) {}
}
